<template>
    <div class="pcga-tab">
        <vxe-toolbar
            size="small"
            perfect
            :export="true"
            :refresh="{ query: refreshData }"
            :print="true"
        >
            <template #buttons>
                <vxe-input
                    v-model="listQuery.key_word"
                    type="search"
                    placeholder="Search table"
                    @change="searchEvent"
                    style="margin-left:0.3vw;"
                ></vxe-input>
            </template>
        </vxe-toolbar>
        <vxe-table
            :row-key="true"
            ref="xTable"
            row-id="id"
            :loading="table_data.loading"
            :data="table_data.tableData"
            style="font-family: Arial, Helvetica, sans-serif;color:#000000"
            size="small"
            border="full"
            max-height="500"
            :export-config="{}"
            :query="loadData"
            :sort-config="table_data.sortConfig"
            @sort-change="customSortMethod"
        >
            <vxe-table-column
                v-for="col in table_data.tableColumn"
                :key="col.field"
                :field="col.field"
                :title="col.title"
                :width="col.width"
                :title-help="col.msg"
                :sortable="col.sort"
                type="html"
            ></vxe-table-column>
            <vxe-table-column
                field="id"
                title="操作"
                width="15%"
                :title-help= "{ message: 'log and restart task' }"
            >
                <template #default="{ row }">
                    <el-button
                        type="success"
                        @click="seeLog(row.kggsee_log)"
                        size="small"
                    >日志</el-button>
                    <el-button
                        type="danger"
                        @click="restartTask(row.task_id_raw)"
                        size="small"
                    >重启</el-button>
                </template>
            </vxe-table-column>
        </vxe-table>
        <vxe-pager
            :loading="table_data.loading"
            :current-page="listQuery.page"
            :page-size="listQuery.limit"
            :total="table_data.total"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="handletablePageChange"
            style="font-family: Arial, Helvetica, sans-serif;color:#000000"
            size="small"
            :page-sizes="[10, 20, 100, { label: 'Full', value: -1 }]"
            perfect
        ></vxe-pager>
        <el-dialog
            title="KGGSEE Log"
            :visible.sync="dialogVisible"
            width="80%"
            >
            <span v-for="line,idx in kggsee_log" :key="idx">{{line}}<br></span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">退出</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ["table_data", "loadData","restartTaskByID"],
    data: function () {
        return {
            total:0,
            listLoading:true,
            listQuery:{
                page: 1,
                limit: 10,
                sort: '',
                key_word:'',
            },
            kggsee_log:['no log'],
            dialogVisible:false,
        }
    },
    mounted: function () {
        this.listQuery.sort=this.table_data.sort_key
        this.getCurrentTable()
    },
    methods: {
        refreshData(){
            this.listQuery={
                page: 1,
                limit: 10,
                sort: this.table_data.sort_key,
                key_word:'',
            }
            this.getCurrentTable();
        },
        searchEvent() {
            this.getCurrentTable();
        },
        handletablePageChange({ currentPage, pageSize }) {
            this.listQuery.page=currentPage
            this.listQuery.limit=pageSize
            this.getCurrentTable();
        },
        getCurrentTable() {
            this.listQuery.key_word=this.listQuery.key_word.trim()
            this.loadData(this.listQuery);
        },
        customSortMethod(data) {
            var { property, order } = data
            if(property === 'time_str'){
                property='submit_time' 
            }
            if (order === 'asc') {
                this.listQuery.sort = '+'+property
            } else {
                this.listQuery.sort = '-'+property
            }
            this.getCurrentTable()
        },
        seeLog(log){
            if(log){
                this.kggsee_log=log.split('\n')
            }else{
                this.kggsee_log=['no log']
            }
            this.dialogVisible=true
        },
        restartTask(task_id){
            this.restartTaskByID(task_id);
        }
    }
}
</script>



<style>
.vxe-table--render-default.size--mini .vxe-body--column:not(.col--ellipsis) {
    padding: 4px 0;
}

.vxe-table--render-default.size--small .vxe-body--column:not(.col--ellipsis) {
    padding: 6px 0;
}

.keyword-lighten {
    color: #000;
    background-color: #ffc400;
}
</style>



// WEBPACK FOOTER //
// src/components/plot/rt_admin_table.vue